import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCodeBranch, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import Branches from '../Companies/Branches/Branches';
import Loader from '../Layout/Loader';
import useSettingsCompany from './useSettingsCompany';
import SettingsBreadcrumb from './SettingsBreadcrumb';
import './settings.scss';

const BranchesSettings = () => {
  const { t } = useTranslation('translations');
  const {
    company,
    setCompany,
    getCompany,
    loading,
    isAdminMode,
    getBackUrl,
  } = useSettingsCompany();

  const [viewEditBranch, setViewEditBranch] = useState(false);

  if (loading || !company) {
    return <Loader />;
  }

  return (
    <div className="settings-subpage">
      <SettingsBreadcrumb
        items={[{ label: t('company.branches') }]}
        company={company}
        isAdminMode={isAdminMode}
      />

      <div className="settings-subpage__header">
        <Link to={getBackUrl()} className="settings-subpage__back-btn">
          <FontAwesomeIcon icon={faArrowLeft} />
        </Link>
        <h2 className="settings-subpage__title">
          <span className="settings-subpage__icon">
            <FontAwesomeIcon icon={faCodeBranch} />
          </span>
          {t('company.branches')}
        </h2>
        {company && (
          <span className="settings-subpage__company-badge">
            {company.name}
          </span>
        )}
      </div>

      <Branches
        company={company}
        setCompany={setCompany}
        getCompany={getCompany}
        viewEditBranch={viewEditBranch}
        setViewEditBranch={setViewEditBranch}
      />
    </div>
  );
};

export default BranchesSettings;
